module.exports = function(h, row, name) {
    let length = row.outlets.length;

    if (length < 1) {
        return <i>No {name} assigned</i>;
    }

    if (length === 1) {
        return row.outlets[0].name;
    }

    return (
        <i>
            Assigned to {row.outlets.length} {name}
        </i>
    );
};



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/inventory/pricebook/outlet.jsx